import {httpClient} from "../../service";
import {Button} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {HttpMethod} from "../../model";
import ReactDOM from "react-dom";
import QRCode from 'qrcode.react';
import {TtaPrevModel, TtaSecModel, VerifyConfigModel} from '../verifications/VerifyConfigModel';

const T4Detail = (props: any) => {
    const item: TtaSecModel = props.item;
    const configModel: VerifyConfigModel = props.model;
    const [entity, setEntity] = useState<TtaSecModel>(item);
    const [prev, setPrev] = useState<TtaPrevModel>({});
    const [loading, setLoading] = useState<boolean>(false);
    const [confirm,setConfirm]=useState(false);
    const qrTd = `qrTd${item.idx}`;
    const qrDiv = `qrDiv${item.idx}`;
    const verifyClick = async (e: any) => {
        e.preventDefault();
        console.log(`click button id=${e.target}`);

        const qrId = document.getElementById(qrDiv);
        setLoading(true);
        const url = `test/tta4`;
        const options = {
            method: HttpMethod.PUT,
            url,
            body: item
        }
        const act = await httpClient(options);

        setLoading(false);

        if (act.result) {
            const r = act.data;
            setEntity({
                ...entity,
                myCouponCnt: r.myCouponCnt,
                availCnt: r.availCnt,
                savePoint: r.savePoint,
                shopCnt: 1,
                result: r.result,
                resultMsg: r.resultMsg
            });
            setConfirm(true);
            if (qrId) {
                qrId.remove();
            }

        } else {
            alert(act.errorMsg);
        }
    }
    const qrCodeClick = async (e: any) => {
        e.preventDefault();
        let id = document.getElementById(qrDiv);
        const qrId = document.getElementById(qrTd);
        console.log(`qrId:${qrId},infoId:${item.infoId}`);
        if (qrId == null) return;
        if (id != null) {
            id.remove();
            return;
        }
        const body = {codeNum: `${item.idx}_${item.infoId}`, memberId: configModel.memberId};

        setLoading(true);
        const url = `test/tta4/qr`;
        const options = {
            method: HttpMethod.POST,
            url,
            body
        }
        const act = await httpClient(options);
        setLoading(false);

        if (act.result) {
            const qrModel: TtaSecModel = act.data;
            if (qrModel.prevData) {
                setPrev(qrModel.prevData);
            } else {
                setPrev({});
            }
            const qrCode = `qrTTA4_${qrModel.encCode}`;
            let tag = document.createElement("div");
            tag.setAttribute("id", qrDiv);
            qrId.appendChild(tag);
            const id = document.getElementById(qrDiv);

            ReactDOM.render(<QRCode value={qrCode} includeMargin={true}/>, id);
        } else {
            alert(act.errorMsg);
        }


    }
    //let resultMsg: string = '';
    useEffect(() => {
        //resultMsg = '검증전';
        if (item.id) {
            console.log(`id:${item.id},difSec=${item.difSec}`);
        }
    }, [item.idx]);

    const setPrevResult = () => {
        let rvalue = '';
        if (prev.result) {
            if (prev.result === true) {
                rvalue = '성공';
            } else {
                rvalue = `<div class='red'>실패<div class="tta-error-msg">${entity.resultMsg}</div></div>`;
            }
        } else {
            rvalue = 'N/A';
        }
        return rvalue;
    }
    const setResult = () => {
        let rvalue = '';
        if (entity.result) {
            if (entity.result===true) {
                rvalue = '성공';
            } else {
                rvalue = `<div class='red'>실패<div class="tta-error-msg">${entity.resultMsg}</div></div>`;
            }
        } else {
            rvalue = 'N/A';
        }
        return rvalue;
    }
    return (

        <>
            <tr>
                <td>{entity.idx}</td>
                <td>{prev.ssoKey}</td>
                <td>{prev.savePoint}</td>
                <td>{prev.shopCnt}</td>
                <td>{prev.couponCnt}</td>
                <td>{prev.loginDttm}</td>
                <td>
                    <div dangerouslySetInnerHTML={{__html: setPrevResult()}}></div>
                </td>
                <td>{
                    confirm===false ? (
                    <Button className="btn-secondary" size="sm" onClick={qrCodeClick} disabled={loading}
                            style={{width: '80px', marginBottom: '10px'}}>QR스캔</Button>
                    ):('적립')
                }

                </td>
                <td className={'align-left'}>
                    <div className={'flex'}>
                        <div id={qrTd}>

                        </div>
                        <div
                            dangerouslySetInnerHTML={{__html: `${prev.memo ? prev.memo.replaceAll('\n', '<br />') : ''}`}}></div>
                    </div>
                </td>
                <td>
                    {entity.savePoint}
                </td>
                <td>
                    {entity.shopCnt}
                </td>
                <td>
                    {entity.myCouponCnt}
                </td>
                <td>
                    {entity.availCnt}
                </td>
                <td>
                    {confirm===true ? (<div dangerouslySetInnerHTML={{__html: setResult()}}></div>) : (
                        <Button className="btn-primary" size="sm" onClick={verifyClick} disabled={loading}
                                style={{width: '80px'}}>확인</Button>)}
                </td>
            </tr>

        </>
    )
}
export default T4Detail;
